import React from 'react';
import cn from 'classnames';
import { Spring, animated } from 'react-spring';

import styles from './style.css';

const FullScreenPage = ({ children, style, location: { pathname } }) => (
  <Spring native to={style}>
    {computedStyle => (
      <animated.div
        style={computedStyle}
        className={cn(styles.full__screen__page, {
          [styles.full__screen__page__flow]: pathname === '/contact'
        })}
      >
        {children}
      </animated.div>
    )}
  </Spring>
);

export default FullScreenPage;
